import { render, staticRenderFns } from "./CreateTemplateDocument.vue?vue&type=template&id=5905b7ac&"
import script from "./CreateTemplateDocument.vue?vue&type=script&lang=ts&"
export * from "./CreateTemplateDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports